"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageActionsMenu = void 0;
var lodash_1 = require("lodash");
var ActionMenu_1 = require("../../../../../ActionMenu");
var react_1 = __importStar(require("react"));
var ImageActionsMenu = function (_a) {
    var id = _a.id, invert = _a.invert, setUnderEditImageData = _a.setUnderEditImageData, setImageUnderEdit = _a.setImageUnderEdit, setShowDeleteImageModal = _a.setShowDeleteImageModal, publicUrl = _a.publicUrl, imageData = _a.imageData, handleReplaceSingleImage = _a.handleReplaceSingleImage, handleUpload = _a.handleUpload, isInRTE = _a.isInRTE;
    var inputRef = (0, react_1.useRef)(null);
    return (react_1.default.createElement("div", { style: __assign({ padding: "0.5rem" }, (isInRTE ? { display: 'none' } : {})) },
        react_1.default.createElement("input", { ref: inputRef, type: "file", accept: "image/*", onChange: function (e) {
                handleUpload({
                    files: e.target.files,
                    publicUrlToReplace: publicUrl,
                    callback: function (_a) {
                        var successfulUploads = _a.successfulUploads;
                        handleReplaceSingleImage({
                            publicUrl: publicUrl,
                            newImage: successfulUploads[0],
                        });
                        //pending
                    },
                });
            }, style: { display: "none" } }),
        react_1.default.createElement(ActionMenu_1.ActionMenu, { popOutOfOverflowHiddenParent: true, ButtonComp: "ButtonPrimary", iconSize: "M", invert: invert, actions: [
                {
                    /**
                     * imp. to attach this comp id to this action's id so that when a
                     * click is triggered from outside (ImageInputNode Lexical), it
                     * indeed clicks this button and not the button of some other ImageInput
                     */
                    id: "".concat(id, "_editImage"),
                    display: "Edit",
                    onClick: function (e) {
                        setUnderEditImageData((0, lodash_1.cloneDeep)(imageData));
                        setImageUnderEdit && setImageUnderEdit(true); //comes from ImageInput context if used inside it
                    },
                },
                {
                    id: "".concat(id, "_replaceImage"),
                    display: "Replace",
                    onClick: function () { return inputRef.current.click(); },
                },
                {
                    id: "".concat(id, "_deleteImage"),
                    display: "Delete",
                    onClick: function (e) { return setShowDeleteImageModal({ publicUrl: publicUrl }); },
                },
            ] })));
};
exports.ImageActionsMenu = ImageActionsMenu;
